export default __webpack_public_path__ + "static/media/SzymonGornik_PMI.f21510a3.jpg";